import { AfterContentInit, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';
import { Geolocation } from '@capacitor/geolocation';
import { GpsBackgroundService } from '@core/services/gps-background.service';
import { LoaderService } from '@core/services/loader.service';
import { PushNotificationService } from '@core/services/push-notification.service';
import { SessionService } from '@core/services/session.service';
import { Platform } from '@ionic/angular';
import { Subject, takeUntil } from 'rxjs';
@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent implements OnInit, AfterContentInit {
  public loader: boolean = false;
  public loadingSession: boolean = false;
  public version: number = null;
  private destroy: Subject<void> = new Subject<void>();
  constructor(
    private _gpsBackgrond: GpsBackgroundService,
    private _loader: LoaderService,
    private _cd: ChangeDetectorRef,
    private platform: Platform,
    private _session: SessionService,
    private _pushNotifications: PushNotificationService,
    private _router: Router,
  ) {
    this._loader.obs().pipe(takeUntil(this.destroy)).subscribe(r => {
      this.loader = r;
      this._cd.detectChanges();
    });
  }
  async ngOnInit(): Promise<void> {
    this._session.loading.subscribe(loading => this.loadingSession = loading);
    this.subscribeToAppStateChange();
    this._session.session.pipe(takeUntil(this.destroy)).subscribe(async session => {
      await this._pushNotifications.initializePushNotifications(session);
    });
  }
  async ngAfterContentInit(): Promise<void> {
    const session = this._session.getSession();
    if (!session?.jwt) {
      return;
    }
    if (Capacitor.getPlatform() !== 'web') {
      try {
        const granted = await this.checkAndRequestLocationPermission();
        if (!granted) {
          return;
        }
        await this._gpsBackgrond.init();
      } catch (error: any) {
        throw Error(`Error al inicializar el GPS en la plataforma nativa,${error.message}`);
      }
    }
  }
  async checkAndRequestLocationPermission() {
    if (!this.platform.is('capacitor')) {
      return true;
    } else {
      const permissionStatus = await Geolocation.checkPermissions();
      if (permissionStatus.location === 'granted') {
        return true;
      } else {
        await this._router.navigate(['gps/consent'], { queryParams: { redirectUrl: '/home/dashboard' } });
        return false;
      }
    }
  }
  private subscribeToAppStateChange() {
    if (this.platform.is('capacitor')) {
      App.addListener('appStateChange', async (state: any) => {
        if (!state.isActive) {
          this._session.stopLoadBindingUnit();
        }
      });
    } else {
      document.addEventListener('visibilitychange', () => {
        if (document.visibilityState === 'visible') {
          this._session.loadSession(false);
        } else {
          this._session.stopLoadBindingUnit();
        }
      });
    }
  }
}
